import { Divider, Drawer, Typography } from 'antd'
import { useState } from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { IsinRatingHistory } from './IsinRatingHistory'
import { UpdateIsinRating } from './UpdateIsinRating'

interface UpdateIsinProps {
  isin: string
  isVisible: boolean
  onClose: () => void
}

export const UpdateIsinRatingDrawer = ({ isin, isVisible, onClose }: UpdateIsinProps) => {
  const [shouldUpdateSibling, setShouldUpdateSibling] = useState(false)

  const onUpdateRatingSuccess = () => setShouldUpdateSibling(true)

  const onReloadIsinRatingHistory = () => setShouldUpdateSibling(false)

  return (
    <Drawer
      title="Update ISIN Rating"
      placement="right"
      open={isVisible}
      onClose={onClose}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <Typography.Title level={5}>Update Isin Rating</Typography.Title>
      <UpdateIsinRating isin={isin} onSuccess={onUpdateRatingSuccess} />
      <Divider />
      <Typography.Title level={5}>Isin Rating History</Typography.Title>
      <IsinRatingHistory isin={isin} shouldRefreshRatings={shouldUpdateSibling} onSuccess={onReloadIsinRatingHistory} />
    </Drawer>
  )
}
